"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorStatusToHttpStatusCode = void 0;
const enums_1 = require("./enums");
/** Should be used for HTTP REST requests, generally not GraphQL. */
exports.ErrorStatusToHttpStatusCode = {
    [enums_1.ErrorStatusCode.OUTDATED_VERSION]: 400,
    [enums_1.ErrorStatusCode.UNAUTHENTICATED]: 401,
    [enums_1.ErrorStatusCode.UNAUTHORIZED]: 403,
    [enums_1.ErrorStatusCode.TOO_MANY_REQUESTS]: 429,
    [enums_1.ErrorStatusCode.INTERNAL_SERVER_ERROR]: 500,
};
